// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2sqMT","fileDisabled":"File_fileDisabled__vjEag"};